/** @format */

import React from 'react';
import FilterOptions from '../../utilities/filter_options';

export default class extends React.Component {
    /**
     * On mount, focus our search filter box
     */
    componentDidMount() {
        this.refs.searchFilterBox.focus();
    }

    sort = (a, b) => {
        const filterA = FilterOptions()[a];
        const filterB = FilterOptions()[b];
        const aName = filterA.name.toLowerCase();
        const bName = filterB.name.toLowerCase();
        if (aName < bName) return -1;
        if (aName > bName) return 1;
        return 0;
    };

    /**
     * Allow the user to click anywhere but children to close
     * https://gist.github.com/pstoica/4323d3e6e37e8a23dd59
     * http://stackoverflow.com/questions/11592966/get-the-newly-focussed-element-if-any-from-the-onblur-event/11592974#11592974
     * @param e
     */
    onBlur = e => {
        const target = e.currentTarget;

        setTimeout(
            function () {
                // Make sure we are not clicking one of my children
                if (!target.contains(document.activeElement)) {
                    this.props.onCancel();
                }
            }.bind(this),
            0
        );
    };

    render() {
        return (
            <div
                tabIndex="0"
                ref="searchFilterBox"
                className="search__filter-box"
                onBlur={this.onBlur}>
                <div className="bg-dark text-white">
                    <div className="p-1 text-nowrap">Choose a Filter</div>
                    <div className="filter-box__filters">
                        {this.props.list.sort(this.sort).map((filter_key, i) => {
                            let filter = FilterOptions()[filter_key];
                            return (
                                <button
                                    key={i}
                                    onClick={this.props.onSelect}
                                    data-value={JSON.stringify(filter)}
                                    style={{border: 'solid 1px #FFF'}}
                                    className="btn btn-secondary filter-box__filter text-nowrap w-100">
                                    <i className="fa fa-filter" /> {filter.name}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
